import { ContractMessage } from '../../../../types/ContractMessage';
import { formatDate } from '../../../common/helpers/formatDate.helper';
import { translate } from '../../../common/helpers/translate.helper';
import { Characters } from '../../../common/helpers/unicode.helper';

interface ContractTableValidityDisplayProps {
    contract: ContractMessage;
}

export const ContractTableValidityDisplay = ({ contract }: ContractTableValidityDisplayProps) => {
    const formattedFromDate = contract.validFrom ? formatDate({ date: contract.validFrom }) : undefined;

    if (!formattedFromDate) {
        return null;
    }

    const formattedUntilDate = contract.validUntil
        ? formatDate({ date: contract.validUntil })
        : translate('contracts.validity.evergreen');

    return (
        <>
            {formattedFromDate}
            {Characters.NO_BREAK_SPACE}
            {Characters.RIGHTWARDS_ARROW}
            {Characters.NO_BREAK_SPACE}
            {formattedUntilDate}
        </>
    );
};
